import React, { useEffect } from 'react';
import { Modal, Box, Title, Group, Button, Paper, Text, Table, Space } from '@mantine/core';
import { baseUrl } from '../../../../Constants/constant';
import useFetch from '../../../../Customhooks/useFetch';
import classes from '../FactoryTableData.module.css'

const ViewProductRow = ({ isOpen, onClose, productId }: any) => {
  const token = localStorage.getItem("token");

  const { data: factoryData, error, fetchData: getProductData } = useFetch({
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      token: token,
    },
  });

  useEffect(() => {
    if (isOpen && productId) {
      getProductData(`${baseUrl}admin/factories/${productId}`);
    }
  }, [isOpen, productId]);

  const rows = factoryData?.data?.rows[0]?.FactoryProcesses?.map((component: any, index: number) => (
    <Table.Tr key={component.id}>
      <Table.Td>{index + 1}</Table.Td>
      <Table.Td>{component?.Process?.process_name}</Table.Td>
      <Table.Td>{component?.percentage_of_factory} %</Table.Td>
    </Table.Tr>
  ));

  return (
    <Modal opened={isOpen} onClose={onClose} size="100%" centered withCloseButton={false}>
      <Box className="flex">
        <Title order={4}>{factoryData?.data?.rows[0]?.factory_name}</Title>
      </Box>
      <Paper shadow="xs" className="p-4 rounded-lg">
          <Text className="mt-4">
            {factoryData?.data?.rows[0]?.factory_address}
          </Text>

        {/* Product Components section */}
        <Box className="mt-4">
          <Space h={'lg'} />
          <Title order={5}>Processes</Title>
          <Table striped className={classes.customtable}>
            <Table.Thead>
              <Table.Tr style={{ backgroundColor: '#4040401A' }}>
                <Table.Th>S No.</Table.Th>
                <Table.Th>Process Name</Table.Th>
                <Table.Th>Percentage (%) of Factory for Process</Table.Th>
                <Table.Th></Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {rows}
            </Table.Tbody>
          </Table>
        </Box>
      </Paper>
          <Space h={'lg'} />
        <Space h={'lg'} />
      <Group className="mt-4 justify-center">
        <Button variant="filled" color="#404040" className="w-32 rounded-lg" onClick={onClose}>
          OK
        </Button>
      </Group>
    </Modal>
  );
};

export default ViewProductRow;